<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'OrdersHourlyChart',
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: Number,
      default: 200
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
}
</style> 